var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowLeft = function SvgArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.431 3.098a.333.333 0 0 1 .472.471L2.805 7.667H13.19a.333.333 0 1 1 0 .666H2.805l4.098 4.098a.333.333 0 1 1-.472.471L1.765 8.236a.333.333 0 0 1 0-.472L6.43 3.098Z",
    fill: "currentColor"
  })));
};

export { SvgArrowLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik02LjQzMTI5IDMuMDk3NjNDNi41NjE0NiAyLjk2NzQ2IDYuNzcyNTIgMi45Njc0NiA2LjkwMjY5IDMuMDk3NjNDNy4wMzI4NyAzLjIyNzgxIDcuMDMyODcgMy40Mzg4NiA2LjkwMjY5IDMuNTY5MDRMMi44MDUwNiA3LjY2NjY3SDEzLjE4OTFDMTMuMzczMiA3LjY2NjY3IDEzLjUyMjUgNy44MTU5IDEzLjUyMjUgOEMxMy41MjI1IDguMTg0MDkgMTMuMzczMiA4LjMzMzMzIDEzLjE4OTEgOC4zMzMzM0gyLjgwNTA2TDYuOTAyNjkgMTIuNDMxQzcuMDMyODcgMTIuNTYxMSA3LjAzMjg3IDEyLjc3MjIgNi45MDI2OSAxMi45MDI0QzYuNzcyNTIgMTMuMDMyNSA2LjU2MTQ2IDEzLjAzMjUgNi40MzEyOSAxMi45MDI0TDEuNzY0NjIgOC4yMzU3QzEuNjM0NDUgOC4xMDU1MyAxLjYzNDQ1IDcuODk0NDcgMS43NjQ2MiA3Ljc2NDNMNi40MzEyOSAzLjA5NzYzWiIgZmlsbD0iY3VycmVudENvbG9yIiAvPgo8L3N2Zz4K";